"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Item = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "Item",
  class: "pl-i1p75wwu",
  vars: {
    "i1p75wwu-0": [({
      order
    }) => order],
    "i1p75wwu-1": [({
      hide
    }) => hide ? 'hidden' : 'visible'],
    "i1p75wwu-2": [({
      open
    }) => open ? 'flex' : 'none'],
    "i1p75wwu-3": [({
      open
    }) => open ? 'rotate(-180deg)' : ''],
    "i1p75wwu-5": [({
      hide
    }) => hide ? 'hidden' : 'visible'],
    "i1p75wwu-6": [({
      invert
    }) => invert ? _intents.default.ux.boxHighContrast.foregroundColor : _intents.default.ux.box.foregroundColor]
  }
});
const IconChevronDown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconChevronDown",
  class: "pl-i18az6ob"
});
const ItemTrigger = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ItemTrigger",
  class: "pl-i1ulk1u5"
});

/**
 * NavItem component.
 *
 * @param {Object} props React props
 * @param {string} props._name Navitem Tracking name
 * @param {boolean} props.hide Whether to hide the drop down or not (usually used for "more" dropdown)
 * @param {number} props.order The list order of the DropDown
 * @param {boolean} props.invert Whether to invert to dark theme,
 * @returns {React.ReactElement} NavItem component
 * @public
 */

const NavItem = /*#__PURE__*/(0, _react.forwardRef)(({
  _name,
  dataCy = 'nav-item',
  order,
  invert,
  hide,
  itemText,
  children,
  ...rest
}, ref) => {
  const [open, setOpen] = (0, _react.useState)(false);
  const refItemText = (0, _react.useRef)(null);
  _patternLibraryUtils.tracking.useTracking(refItemText);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, true, false);
  function handleDropDown({
    currentTarget,
    type,
    relatedTarget,
    key
  }) {
    const dropBtn = currentTarget;
    const dropList = dropBtn.querySelector('ul');
    switch (type) {
      case 'focus' || 'mouseenter':
        setOpen(true);
        break;
      case 'blur':
        if (!currentTarget.contains(relatedTarget)) {
          setOpen(false);
        }
        break;
      case 'mouseleave':
        setOpen(false);
        break;
      default:
        if (type === 'keydown' && key !== 'Enter') {
          return;
        }
        if (global.getComputedStyle(dropList).display === 'flex') {
          setOpen(false);
        } else {
          setOpen(true);
        }
    }
  }
  const dropDownControl = children && {
    onKeyDown: handleDropDown,
    onMouseEnter: handleDropDown,
    onMouseLeave: handleDropDown,
    onFocus: handleDropDown,
    onBlur: handleDropDown
  };
  return /*#__PURE__*/_react.default.createElement(Item, (0, _extends2.default)({
    "data-cy": dataCy,
    ref: ref,
    open: open,
    hide: hide,
    invert: invert,
    order: order ?? 'unset',
    "aria-haspopup": !!children
  }, dropDownControl, rest), /*#__PURE__*/_react.default.createElement(ItemTrigger, (0, _extends2.default)({
    "data-cy": "item-text",
    ref: refItemText
  }, trackingProps), itemText, children && /*#__PURE__*/_react.default.createElement(IconChevronDown, {
    "data-cy": "down-chevron",
    className: "more-chevron"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down"
  }))), children);
});
NavItem.displayName = 'NavItem';
NavItem.propTypes = {
  _name: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  itemText: _propTypes.default.node,
  order: _propTypes.default.number,
  invert: _propTypes.default.bool,
  hide: _propTypes.default.bool,
  children: _propTypes.default.node
};
var _default = exports.default = NavItem;